import { render } from "./two-factor-auth.vue?vue&type=template&id=887daaf4"
import script from "./two-factor-auth.vue?vue&type=script&lang=js"
export * from "./two-factor-auth.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__